// components/Pagination.jsx
import React from 'react';

const Pagination = ({ totalPages, currentPage, onPageChange, scrollTargetId }) => {
  if (totalPages <= 1) return null;

  const isPrevDisabled = currentPage === 1;
  const isNextDisabled = currentPage === totalPages;

  const scrollToTop = () => {
    if (scrollTargetId) {
      const element = document.getElementById(scrollTargetId);
      if (element) {
        element.scrollIntoView({ behavior: 'auto', block: 'start' });
      }
    }
  };

  const handlePageClick = (pageNum, e) => {
    e.preventDefault();
    if (pageNum === currentPage) return;
    onPageChange?.(pageNum);
    scrollToTop();
  };

  const handlePrev = (e) => {
    e.preventDefault();
    if (isPrevDisabled) return;
    onPageChange?.(currentPage - 1);
    scrollToTop();
  };

  const handleNext = (e) => {
    e.preventDefault();
    if (isNextDisabled) return;
    onPageChange?.(currentPage + 1);
    scrollToTop();
  };

  return (
    <ul className="pagination">
      {/* Previous */}
      <li className={'page-item' + (isPrevDisabled ? ' disabled' : '')}>
        <a
          className="page-link"
          href="#"
          tabIndex={isPrevDisabled ? -1 : 0}
          aria-disabled={isPrevDisabled ? 'true' : 'false'}
          onClick={handlePrev}
        >
          <svg
            className="icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 19.75 32"
            aria-hidden="true"
          >
            <title>Chevron left</title>
            <path
              d="M25.88,28.28L13.59,16,25.88,3.72,22.16,0l-16,16,16,16Z"
              transform="translate(-6.13 0)"
            />
          </svg>
          <span className="hidden-text">Previous</span>
        </a>
      </li>

      {/* Page numbers */}
      {Array.from({ length: totalPages }, (_, i) => {
        const pageNum = i + 1;
        const isActive = pageNum === currentPage;

        return (
          <li
            key={pageNum}
            className={'page-item' + (isActive ? ' active' : '')}
          >
            <a
              className="page-link"
              href="#"
              aria-current={isActive ? 'page' : undefined}
              onClick={(e) => handlePageClick(pageNum, e)}
            >
              {pageNum}
            </a>
          </li>
        );
      })}

      {/* Next */}
      <li className={'page-item' + (isNextDisabled ? ' disabled' : '')}>
        <a
          className="page-link"
          href="#"
          tabIndex={isNextDisabled ? -1 : 0}
          aria-disabled={isNextDisabled ? 'true' : 'false'}
          onClick={handleNext}
        >
          <svg
            className="icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 19.75 32"
            aria-hidden="true"
          >
            <title>Chevron right</title>
            <path
              d="M6.13,28.28L18.41,16,6.13,3.72,9.84,0l16,16-16,16Z"
              transform="translate(-6.13 0)"
            />
          </svg>
          <span className="hidden-text">Next</span>
        </a>
      </li>
    </ul>
  );
};

export default Pagination;
